import React, { useState } from "react";
import { useEffect } from "react";
import { useAlert } from "react-alert";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import api from "../../api";
import { ConsentTerms } from "./consentTerms";
import userAction from "../../redux/users/action";

export const BeforePayTerms = ({
  show,
  handleShow,
  handleClose,
  onStripePay,
}) => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(false);

  const accept = async () => {
    try {
      const validatorsResponse = validators();

      if (validatorsResponse) {
        return alert.show(validatorsResponse);
      }
      setLoader(true);
      const payload = {
        confirmAccount: data.confirmAccount,
        authCard: data.authCard,
        monthlySubscription: data.monthlysubs,
        renewAuto: data.renewAuto,
        nonRefund: data.nonRefund,
        aggreeTerms: data.aggreeTerms,
        understandMisuse: data.understandMisuse,
        unauthTransaction: data.unauthTransaction,
      };

      const response = await api.addSubscriptionConsents(payload);
      // console.log(response);
      if (response?.consent) {
        onStripePay();
        handleClose();
        setLoader(false);
      }
    } catch (error) {
      console.log(error?.message);
      alert.show("Something went wrong");
    }
  };

  const validators = () => {
    if (!data?.confirmAccount) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.authCard) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.monthlysubs) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.renewAuto) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.nonRefund) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.aggreeTerms) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.understandMisuse) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.unauthTransaction) {
      return "Kindly confirm each checkbox to proceed.";
    }
    return false;
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.checked });
  };

  return (
    <Modal size="lg" show={show} onHide={handleClose} centered>
      <Modal.Body>
        <div className="otpModalMain broadcastModal">
          <div className="closeIcon" onClick={handleClose}>
            <i className="fa-solid fa-xmark" />
          </div>
          <div className="showMoreModalM">
            <div className="showMoreModal ">
              <h4 className="my-3 text-center">
                Before You Subscribe, Please Confirm the Following
              </h4>
              <ol>
                <li className="py-2">
                  <p className="desc1 ">
                    <input
                      type="checkbox"
                      name="confirmAccount"
                      className="me-2"
                      onChange={handleChange}
                    />
                    I confirm that I am the owner of this account.
                  </p>
                </li>
                <li className="py-2">
                  <p className="desc1 ">
                    <input
                      type="checkbox"
                      name="authCard"
                      className="me-2"
                      onChange={handleChange}
                    />
                    I confirm that I am using my own credit/debit card or have
                    authorized access to this card.
                  </p>
                </li>
                <li className="py-2">
                  <p className="desc1 ">
                    <input
                      type="checkbox"
                      name="monthlysubs"
                      className="me-2"
                      onChange={handleChange}
                    />
                    I authorize WaqarZaka.net to charge my card for a monthly
                    subscription.
                  </p>
                </li>
                <li className="py-2">
                  <p className="desc1 ">
                    <input
                      type="checkbox"
                      name="renewAuto"
                      className="me-2"
                      onChange={handleChange}
                    />
                    I understand that after my first month’s payment, my
                    subscription will automatically renew each month unless I
                    cancel it in advance.
                  </p>
                </li>
                <li className="py-2">
                  <p className="desc1 ">
                    <input
                      type="checkbox"
                      name="nonRefund"
                      className="me-2"
                      onChange={handleChange}
                    />
                    I understand this is a non-refundable digital subscription,
                    and after 24 hours of purchase, no refund requests will be
                    accepted.
                  </p>
                </li>
                <li className="py-2">
                  <p className="desc1 ">
                    <input
                      type="checkbox"
                      name="aggreeTerms"
                      className="me-2"
                      onChange={handleChange}
                    />
                    I agree to the platform’s{" "}
                    <Link to="/terms-and-conditions">Terms & Conditions</Link>{" "}
                    and <Link to="/privacy-policy"> Privacy Policy.</Link>
                  </p>
                </li>
                <li className="py-2">
                  <p className="desc1 ">
                    <input
                      type="checkbox"
                      name="understandMisuse"
                      className="me-2"
                      id=""
                      onChange={handleChange}
                    />
                    I understand that misuse, account sharing, or reselling
                    content may lead to account suspension without refund.
                  </p>
                </li>
                <li className="py-2">
                  <p className="desc1 ">
                    <input
                      type="checkbox"
                      name="unauthTransaction"
                      className="me-2"
                      onChange={handleChange}
                    />
                    I agree that any unauthorized or fraudulent activity may
                    lead to data disclosure, account suspension, and legal
                    action.{" "}
                    <Link to={"/unauthorized-transaction"}>For more info</Link>
                  </p>
                </li>
              </ol>
            </div>
            <div className="mt-4">
              <button className="themeBtn mx-auto" onClick={accept}>
                Accept
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
